import React from 'react'
import styled from 'styled-components'
import { Box, Text } from '../../Shared/Base'

const Icon01 = () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path d="M5.425 19.332h-2.5a.417.417 0 00-.417.417v.416c0 .46.374.834.834.834h1.666c.46 0 .833-.374.833-.834v-.416a.417.417 0 00-.416-.417zm11.666 0h-2.5a.417.417 0 00-.417.417v.416c0 .46.373.834.834.834h1.666c.46 0 .833-.374.833-.834v-.416a.417.417 0 00-.416-.417zm1.25-3.368c0-.277-.11-.542-.305-.737l-1.02-1.018a.414.414 0 01-.093-.14l-1.666-4.157a1.243 1.243 0 00-1.16-.786H5.916c-.512 0-.971.313-1.158.79l-1.666 4.157a.414.414 0 01-.093.14l-1.017 1.014c-.197.195-.308.46-.307.737v1.494c.001.575.468 1.042 1.043 1.04H17.3c.575 0 1.04-.465 1.04-1.04v-1.494zM5.813 13.292a.417.417 0 01-.386-.571l.666-1.667a.416.416 0 01.387-.261h7.056c.17 0 .323.103.387.261l.666 1.667a.417.417 0 01-.386.571h-8.39zm13.974-2.822a.833.833 0 00-.053-1.176L11.13 1.439a1.656 1.656 0 00-2.25 0l-8.6 7.855a.833.833 0 001.124 1.23l8.322-7.598a.417.417 0 01.562 0l8.322 7.598c.34.31.866.286 1.176-.054z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" transform="translate(.013 .999)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)

const Icon02 = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.182 8.182A1.818 1.818 0 0016.364 10v2.727H3.636V10A1.818 1.818 0 100 10v4.545c0 1 .818 1.819 1.818 1.819h16.364c1 0 1.818-.819 1.818-1.819V10a1.818 1.818 0 00-1.818-1.818zm-2.727-4.546H4.544c-1 0-1.818.819-1.818 1.819v1.959a2.726 2.726 0 011.818 2.559v1.845h10.91V9.973c0-1.182.763-2.182 1.818-2.56V5.456c0-1-.819-1.819-1.819-1.819z" />
  </svg>
)

const Icon03 = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.332 8.75a2.774 2.774 0 002.217 1.042h.012A2.773 2.773 0 008.777 8.76c.084-.11.305-.393.471-.601a.416.416 0 00.048-.447 9.814 9.814 0 01-1.083-4.49V1.25c0-.69-.56-1.25-1.25-1.25h-.838c-.69 0-1.25.56-1.25 1.25v1.973a9.869 9.869 0 01-1.067 4.454.418.418 0 00.046.448c.171.218.405.527.478.625zm2.21-2.5a.834.834 0 110 1.667.834.834 0 010-1.667zm3.431 3.198a.221.221 0 00-.21.084 4.018 4.018 0 01-3.202 1.51h-.017a4.014 4.014 0 01-3.203-1.533.23.23 0 00-.4.063 9.318 9.318 0 00-.566 3.143v5.202c0 1.15.933 2.083 2.083 2.083h4.167c1.15 0 2.083-.933 2.083-2.083v-5.202a9.323 9.323 0 00-.561-3.122.22.22 0 00-.174-.145zm6.985 9.302h-1.041a.417.417 0 01-.417-.417v-1.406c0-.184.12-.345.294-.399A3.13 3.13 0 0018 13.542c0-.78-.675-5.607-.788-6.382a1.035 1.035 0 00-1.024-.91H13.57a1.03 1.03 0 00-1.027.893c-.112.777-.79 5.616-.79 6.399a3.13 3.13 0 002.206 2.986.417.417 0 01.294.399v1.406c0 .23-.186.417-.416.417h-1.042a.625.625 0 000 1.25h4.166a.625.625 0 000-1.25h-.004zM13.701 7.858a.417.417 0 01.412-.358h1.524c.207 0 .383.152.412.358.05.351.11.784.174 1.25a.418.418 0 01-.417.473h-1.868a.416.416 0 01-.417-.473c.07-.464.13-.896.18-1.25zm.549 6.725a.625.625 0 11.002 0h-.002zm.625-3.125a.625.625 0 111.25 0 .625.625 0 01-1.25 0z" />
  </svg>
)

const Icon04 = () => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M.285.285h19.43v19.43H.285V.285zm1.43 1.43v16.57h7.57V1.715h-7.57zm9 0v16.57h7.57V1.715h-7.57zm-4.79 2.392l2.45 2.573-1.035.986-1.5-1.575-1.5 1.575-1.035-.986 2.45-2.573.085.08.084-.08zm5.952 9.6l1.035-.986 1.5 1.574 1.5-1.574 1.034.985-2.45 2.573-.085-.08-.084.08-2.45-2.573z" />
  </svg>
)

const Icon05 = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2h7V0H2C.9 0 0 .9 0 2v7h2V2zm6 9l-4 5h12l-3-4-2.03 2.71L8 11zm7-4.5c0-.83-.67-1.5-1.5-1.5S12 5.67 12 6.5 12.67 8 13.5 8 15 7.33 15 6.5zM18 0h-7v2h7v7h2V2c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM2 11H0v7c0 1.1.9 2 2 2h7v-2H2v-7z" />
  </svg>
)

const Icon06 = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 9h16v2H4V9zm7-6h2v2h-2V3zM0 3h2v16H0V3zm2-2h9a2 2 0 012 2H0a2 2 0 012-2zm9 12h2v6h-2v-6zm-4 0h2v4H7v-4zm8 0h2v4h-2v-4zM8 5h8a2 2 0 012 2v2H6V7a2 2 0 012-2z" />
  </svg>
)

const Icon09 = () => (
  // Jardin
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.75 9.25H1.25a.625.625 0 00-.625.625v1.25c0 .345.28.625.625.625H2.5v3.125c0 .345.28.625.625.625h8.75c.345 0 .625-.28.625-.625V11.75h1.25c.345 0 .625-.28.625-.625v-1.25a.625.625 0 00-.625-.625zM8.125 6.125c1.726 0 3.125-1.4 3.125-3.125V1.75h-.625c-1.027 0-1.93.502-2.5 1.267V.5h-1.25V8h1.25V6.125z" />
  </svg>
)

const Icon07 = () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path d="M10.74 5.556v-4h-10v18h20v-14h-10zm-6 12h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2v-2h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2v-2h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2v-2h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" transform="translate(.74 .556)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)

const Check = () => (
  <svg width="13" height="11" fill="none" xmlns="http://www.w3.org/2000/svg" className="check">
    <path
      d="M12.567.217c.478.359.575 1.038.216 1.516l-6.5 8.667a1.083 1.083 0 01-1.632.116L.317 6.183A1.083 1.083 0 011.85 4.65L5.3 8.1 11.05.433a1.083 1.083 0 011.518-.216z"
      fill="#919191"
    />
  </svg>
)

const BoxFeatures = styled.ul`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 20px;
  align-items: center;

  @media screen and (max-width: 620px) {
    grid-template-columns: auto auto;
  }

  @media screen and (max-width: 440px) {
    grid-template-columns: auto;
  }

  @media screen and (min-width: 960px) and (max-width: 1200px) {
    grid-template-columns: auto auto;
  }

  li {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      display: flex;
      align-items: center;
    }

    &.disabled {
      color: #dddcdc;
      display: none;

      svg {
        fill: #dddcdc;
      }

      .check {
        opacity: 0;
      }
    }
  }

  svg {
    margin-right: 15px;
    fill: var(--colorText);
  }
`

const ResultFeatures = ({ ad }) => {
  if (ad.new_real_estate) return null

  return (
    <>
      <Box as="hr" className="w-tiny" />
      <Text as="h3" className="h3-like" mt={30} mb={20}>
        Caractéristiques
      </Text>
      <BoxFeatures className="fz-16">
        <li className={ad.features && ad.features.parking ? '' : 'disabled'}>
          <span>
            <Icon01 /> Parking
          </span>
          <Check />
        </li>
        <li className={ad.furnished ? '' : 'disabled'}>
          <span>
            <Icon02 /> Meublé
          </span>
          <Check />
        </li>
        <li className={ad.features && (ad.features.cave || ad.features.box) ? '' : 'disabled'}>
          <span>
            <Icon03 /> Cave / Box
          </span>
          <Check />
        </li>
        <li className={ad.features && ad.features.lift ? '' : 'disabled'}>
          <span>
            <Icon04 /> Ascenseur
          </span>
          <Check />
        </li>
        <li
          className={ad.features && (ad.features.balcony || ad.features.terracy) ? '' : 'disabled'}
        >
          <span>
            <Icon05 /> Balcon / Terrasse
          </span>
          <Check />
        </li>
        <li className={ad.features && ad.features.bath ? '' : 'disabled'}>
          <span>
            <Icon06 /> Baignoire
          </span>
          <Check />
        </li>
        <li className={ad.features && ad.features.garden ? '' : 'disabled'}>
          <span>
            <Icon09 /> Jardin
          </span>
          <Check />
        </li>
        {ad.floor !== null && (
          <li>
            <span>
              <Icon07 /> Étage
            </span>
            {ad.floor === 0 && <span>Rdc</span>}
            {ad.floor === -1 && <span>Dernier étage</span>}
            {ad.floor === 1 && <span>1er étage</span>}
            {ad.floor > 1 && <span>{ad.floor}ème étage</span>}
          </li>
        )}
      </BoxFeatures>
    </>
  )
}

export default React.memo(ResultFeatures)
